<!-- //
侧边分组管理
@author xuyd
@date 2024-08-07
//-->
<template>
  <SideTree ref="refSideTree"
            :width="width"
            :load="getGroupList"
            :default-props="defaultProps"
            default-current-node="first"
            @save="handleGroupSave"
            @up="handleGroupUp"
            @down="handleGroupDown"
            @delete="handleGroupDelete"
            @change="handleGroupChange"
  >
    <template slot-scope="{options, dataList}">
      <GroupDetail ref="refGroupDetail" :options="options" :dataList="dataList" />
    </template>
  </SideTree>
</template>
<script>

import MultiEnvApi from '@/api/sys/sysMultiEnv.api';
import SideTree from '@/components/SideTree/index.vue';
import GroupDetail from './group-detail.vue';

export default {
  name: 'CompMultiEnvGroup',
  components: {
    SideTree
    ,GroupDetail
  },
  data() {
    return {
      defaultProps: {children: 'children', label: 'terminalLabel',maxLevel: 2},
    }
  },
  props: {
    width: {
      type: Number,
      default: 230,
    },
    editMode: {
      type: Boolean,
      default: true,
    },
    queryParams: {
      type: Object,
      default: () => {
        return {}
      }
    },
  },
  methods: {
    getGroupList() {
      return new Promise(resolve => {
        MultiEnvApi.searchList(this.queryParams).then(resp => {
          let root = [{id: '0', parentId: '-1', terminalCode: '', terminalLabel: '全部', children: []}];
          root.push(...resp.data);
          // 统计且标记head和tail
          let treeList = this.$util.listToTree(root,{virtualRoot: true});
          resolve(treeList);
        })
      })
    },
    handleGroupSave(data, resolve) {
      MultiEnvApi.saveGroup(data).then(resp => {
        resolve(resp.data);
      })
    },
    handleGroupUp(data, resolve) {
      MultiEnvApi.upGroup(data).then(resp => {
        resolve(resp.data);
      })
    },
    handleGroupDown(data, resolve) {
      MultiEnvApi.downGroup(data).then(resp => {
        resolve(resp.data);
      })
    },
    handleGroupDelete(data, resolve) {
      MultiEnvApi.deleteGroup(data).then(resp => {
        resolve(resp.data);
      })
    },
    handleGroupChange(data) {
      this.$emit('change', data);
    },
  }

}
</script>

<style lang="less" scoped>
</style>
